import { RTKQueryParams } from 'clickNgo/models/api'

import type { CallingListRankingInput } from '../lib'
import { Campaign, CampaignCallOutcome, CampaignDocument, CampaignObjective } from '../model'

export enum CampaignApiTags {
  CampaignsByOwner = 'CampaignsByOwner',
  CampaignsByISR = 'CampaignsByISR',
  CampaignObjectives = 'CampaignObjectives',
  CampaignDocuments = 'CampaignDocuments',
  CampaignCallingList = 'CampaignCallingList',
  CampaignRatings = 'CampaignRatings',
  CampaignCallOutcomes = 'CampaignCallOutcomes',
}

export type GetCampaignsByISRParams = {
  ISR: string
  page?: number
  pageSize?: number
}

export type GetCampaignsByOwnerParams = {
  owner: string
  page?: number
  pageSize?: number
}

export type GetCampaignExtendedCallingListParams = {
  isr?: string
  campaignId?: number
  page?: number
  pageSize?: number
}

export type GetCampaignCallOutcomesParams = {
  callingListId?: number
  campaignId?: number
  partnerId?: string
  locationId?: string
  page?: number
  pageSize?: number
}

export type GetCampaignObjectivesParams = {
  campaignId?: number
}

export type GetAllISRRatingsParams = {
  campaignId: number
}

export type GetCampaignDocumentsByCampaignIdParams = {
  campaignId?: number
}

export type CreateCallingListParams = RTKQueryParams & {
  campaignId: number
  isr: string
  partnerIds?: string[]
  locationIds?: string[]
  ranking?: CallingListRankingInput
  rankings?: CallingListRankingInput[]
}

export type CreateCallOutcomeParams = Partial<CampaignCallOutcome>

export type CreateCampaignParams = Partial<Campaign>

export type CopyCampaignParams = Partial<Campaign> & { sourceCampaignId: number }

export type CreateCampaignObjectiveParams = Partial<CampaignObjective>

export type UpdateCallOutcomeParams = {
  callOutcome: Partial<CampaignCallOutcome>
}

export type UpdateCallingListParams = RTKQueryParams & {
  entryId: number
  campaignId?: number
  isVisible?: boolean
  ranking?: CallingListRankingInput
}

export type DeleteCallingListRecordParams = {
  entryId: number
  campaignId: number
}

export type DeleteCallingListByCampaignParams = {
  campaignId: number
}

export type UpdateCampaignParams = {
  campaign: Partial<Campaign>
}

export type UpdateCampaignObjectiveParams = CampaignObjective

export type DeleteCampaignObjectiveParams = CampaignObjective

export type UpdateDocumentParams = CampaignDocument

export type UpdateLinkParams = CampaignDocument

export type DeleteLinkParams = Pick<CampaignDocument, 'entryId' | 'campaignId'>

export type UploadDocumentsParams = {
  campaignId: number
  countries: string[]
  isVisible?: 1 | 0
  files: File[]
}

export type AttachLinkParams = {
  campaignId: number
  fileName: string
  url: string
  countries: string[]
  isVisible?: boolean
}

export type DeleteCampaignParams = {
  entryId: number
}
